var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60948 8L6.38281 11.2267L4.66667 9.85375L2.89588 11.2704L2.06296 10.2292L4.66667 8.14625L6.28386 9.44L8.66667 7.05719L9.60948 8Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83913 2L8 2V3.33333H5.86667C5.29561 3.33333 4.90742 3.33385 4.60736 3.35837C4.31508 3.38225 4.16561 3.42553 4.06135 3.47866C3.81046 3.60649 3.60649 3.81046 3.47866 4.06135C3.42553 4.16561 3.38225 4.31508 3.35837 4.60736C3.33385 4.90742 3.33333 5.29561 3.33333 5.86667V10.1333C3.33333 10.7044 3.33385 11.0926 3.35837 11.3926C3.38225 11.6849 3.42553 11.8344 3.47866 11.9387C3.60649 12.1895 3.81046 12.3935 4.06135 12.5213C4.16561 12.5745 4.31508 12.6178 4.60736 12.6416C4.90742 12.6661 5.29561 12.6667 5.86667 12.6667H10.1333C10.7044 12.6667 11.0926 12.6661 11.3926 12.6416C11.6849 12.6178 11.8344 12.5745 11.9387 12.5213C12.1895 12.3935 12.3935 12.1895 12.5213 11.9387C12.5745 11.8344 12.6178 11.6849 12.6416 11.3926C12.6661 11.0926 12.6667 10.7044 12.6667 10.1333V8H14V10.1609C14 10.6975 14 11.1404 13.9705 11.5012C13.9399 11.8759 13.8742 12.2204 13.7094 12.544C13.4537 13.0457 13.0457 13.4537 12.544 13.7094C12.2204 13.8742 11.8759 13.9399 11.5012 13.9705C11.1404 14 10.6975 14 10.1609 14H5.83912C5.30248 14 4.85958 14 4.49878 13.9705C4.12405 13.9399 3.77958 13.8742 3.45603 13.7094C2.95426 13.4537 2.54631 13.0457 2.29065 12.544C2.12579 12.2204 2.06008 11.8759 2.02946 11.5012C1.99998 11.1404 1.99999 10.6975 2 10.1609V5.83913C1.99999 5.30249 1.99998 4.85958 2.02946 4.49878C2.06008 4.12405 2.12579 3.77958 2.29065 3.45603C2.54631 2.95426 2.95426 2.54631 3.45603 2.29065C3.77958 2.12579 4.12405 2.06008 4.49878 2.02946C4.85958 1.99998 5.30249 1.99999 5.83913 2Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53369 4.62825L11.1801 2.98969M11.1801 2.98969L12.7537 4.55418M11.1801 2.98969V7.01469",
    stroke: "#161616",
    strokeWidth: 1.4,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/File Upload.f509c6e8e6a711f77d947f06aad424ae.svg";
export { ForwardRef as ReactComponent };